import { AppBar, Box, Paper, Tab, Tabs } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import AuthService from "../../AuthService";
import BarraTitulo from "../Generico/BarraTitulo";
import Template from "../Generico/Template";

import ConfigurarTimezone from "./components/configurarTimezone";
import TabContainer from "./components/TabContainer";
import TabPanel from "./components/TabPanel";
import { MyTab, VerticalTabs } from "./styles";

const HorarioAbertura = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [horarios, setHorarios] = useState([]);
  const [indexTipo, setIndexTipo] = useState("DELIVERY");
  const { enqueueSnackbar } = useSnackbar();

  const dias = [
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
    "Domingo",
  ];
  useEffect(() => {
    getHorarios();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleSubmit = (horario) => {
    let horariosCopy = [...horarios];
    horario = dateToString(horario);

    let service = new AuthService();

    service
      .post("/horarioAbertura", horario)
      .then((resp) => {
        let index = horariosCopy.findIndex((el) => el.id === resp.id);
        horariosCopy[index] = resp;

        horariosCopy = stringToDate(horariosCopy);

        setHorarios(horariosCopy);

        enqueueSnackbar("Horarios salvos com sucesso", {
          variant: "success",
        });
      })
      .catch(() => {
        enqueueSnackbar("Não foi possivel salvar os horarios", {
          variant: "error",
        });
      });
  };

  const handleChange = (date, name, horario) => {
    const updatedHorarios = horarios.map((h) =>
      h.id === horario.id ? { ...h, [name]: date } : h
    );
    setHorarios(updatedHorarios);
  };

  const getHorarios = () => {
    let service = new AuthService();

    service.get("/horarioAbertura/list").then((resp) => {
      const horariosConvertidos = stringToDate(resp);
      setHorarios(horariosConvertidos);
    });
  };

  const dateToString = (horario) => {
    horario.periodo01Inicio =
      horario.periodo01Inicio.toLocaleTimeString("it-IT");
    horario.periodo01Fim = horario.periodo01Fim.toLocaleTimeString("it-IT");
    horario.periodo02Inicio =
      horario.periodo02Inicio.toLocaleTimeString("it-IT");
    horario.periodo02Fim = horario.periodo02Fim.toLocaleTimeString("it-IT");

    return horario;
  };

  const stringToDate = (horas) => {
    return horas.map((hora) => {
      if (typeof hora.periodo01Inicio === "string") {
        const h1Inicio = new Date();
        const h1Fim = new Date();
        const h2Inicio = new Date();
        const h2Fim = new Date();

        const [h1StartHour, h1StartMinute] = hora.periodo01Inicio.split(":");
        const [h1EndHour, h1EndMinute] = hora.periodo01Fim.split(":");
        const [h2StartHour, h2StartMinute] = hora.periodo02Inicio.split(":");
        const [h2EndHour, h2EndMinute] = hora.periodo02Fim.split(":");

        h1Inicio.setHours(h1StartHour, h1StartMinute);
        h1Fim.setHours(h1EndHour, h1EndMinute);
        h2Inicio.setHours(h2StartHour, h2StartMinute);
        h2Fim.setHours(h2EndHour, h2EndMinute);

        hora.periodo01Inicio = h1Inicio;
        hora.periodo02Inicio = h2Inicio;
        hora.periodo01Fim = h1Fim;
        hora.periodo02Fim = h2Fim;
      }
      return hora;
    });
  };

  const handleChangeRadio = (event, horario) => {
    const updatedHorarios = horarios.map((h) => {
      if (h.id === horario.id) {
        const statusValue =
          event.target.value === h.status.toString() ? 0 : event.target.value;
        return { ...h, status: statusValue };
      }
      return h;
    });
    setHorarios(updatedHorarios);
  };

  const handleChangeTab = (_, newIndex) => {
    setActiveIndex(newIndex);
  };

  const handleChangeTabTipo = (_, newTipo) => {
    setIndexTipo(newTipo);
  };

  const verificaDiaSemana = (indexDiaEscolhido) => {
    const diasNome = [
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
      "Domingo",
    ];

    const index = horarios.findIndex(
      (el) => el.diaSemana === indexDiaEscolhido + 1 && el.tipo === indexTipo
    );

    const horario = horarios[index];

    return (
      <TabContainer
        title={diasNome[indexDiaEscolhido]}
        config={horario}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        handleChangeRadio={handleChangeRadio}
      />
    );
  };

  return (
    <Template documentTitle="Horário de abertura">
      <BarraTitulo
        title="Horário de abertura"
        subTitle="Configure os horários de abertura e fechamento"
      />

      <Box pb={3} mb={2}>
        <ConfigurarTimezone />
      </Box>

      <Paper>
        <AppBar position="static">
          <Tabs
            value={indexTipo}
            onChange={handleChangeTabTipo}
            aria-label="simple tabs example"
            textColor="inherit"
            sx={{
              color: "white",
              "& .MuiTab-root": {
                color: "white",
              },
            }}
          >
            <Tab value="DELIVERY" label="Delivery" {...a11yProps("DELIVERY")} />
            <Tab
              value="COMANDA"
              label="Comanda / Mesa"
              {...a11yProps("COMANDA")}
            />
          </Tabs>
        </AppBar>

        <TabPanel value={indexTipo} index="DELIVERY">
          <Box
            style={{
              display: "flex",
            }}
          >
            <VerticalTabs
              sx={{ minWidth: "12rem" }}
              value={activeIndex}
              onChange={handleChangeTab}
            >
              {dias.map((dia, i) => (
                <MyTab key={i} label={dia} />
              ))}
            </VerticalTabs>
            {verificaDiaSemana(activeIndex)}
          </Box>
        </TabPanel>

        <TabPanel value={indexTipo} index="COMANDA">
          <Box style={{ display: "flex" }}>
            <VerticalTabs
              sx={{ minWidth: "12rem" }}
              value={activeIndex}
              onChange={handleChangeTab}
            >
              {dias.map((dia, i) => (
                <MyTab key={i} label={dia} />
              ))}
            </VerticalTabs>
            {verificaDiaSemana(activeIndex)}
          </Box>
        </TabPanel>
      </Paper>
    </Template>
  );
};

export default HorarioAbertura;
